import styles from "./UserReviews.module.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, EffectCoverflow, Autoplay, Keyboard } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-coverflow";
import ReviewItem from "./ReviewItem";
import { memo } from "react";

function UserReviews({ dictionary, colorOn = false, type }) {
	const reviewsForBGRData = [
		{ location: "US", date: "July 8, 2022", title: "Very useful background removing service", body: dictionary["service is fantastic"], name: "ML", color: true },
		{ location: "ID", date: "Sept 6, 2022", title: "No watermark is great", body: dictionary["i like this website"], name: "AC", color: false },
		{ location: "BR", date: "June 10, 2022", title: "Good customer support", body: dictionary["i like the quality of background removing"], name: "MH", color: true },
		{ location: "IND", date: "Aug 25, 2022", title: "Good value for money", body: dictionary["my work is connected with video editing"], name: "KA", color: false },
		{ location: "ESP", date: "Jan 15, 2022", title: "Great!!", body: dictionary["Best background removing service ever!"], name: "OT", color: true },
		{ location: "COR", date: "July 3, 2022", title: "Love the functionality", body: dictionary["i really like the service"], name: "NR", color: false },
		{ location: "CHI", date: "May 21, 2022", title: "Effective and efficient", body: dictionary["very useful website"], name: "SD", color: true },
		{ location: "FR", date: "Dec 26, 2021", title: "A great service with great support", body: dictionary["this website works great and removes background brilliantly"], name: "MK", color: false },
		{ location: "US", date: "Febr 17, 2022", title: "I love this smart app", body: dictionary["i love this app"], name: "DR", color: true },
		{
			location: "AR",
			date: "Mar 20, 2022",
			title: "I really enjoy removing background in BgRem",
			body: dictionary["I really enjoy removing background in BgRem as it works really quickly and automatically"],
			name: "LO",
			color: false,
		},
	];

	const reviewsForMainData = [
		{ location: "US", date: "July 8, 2022", title: "page_main_reviewhead1", body: dictionary["page_main_review1"], name: "ML", color: true },
		{ location: "ID", date: "Sept 6, 2022", title: "page_main_reviewhead2", body: dictionary["page_name_review2"], name: "AC", color: false },
		{ location: "BR", date: "June 10, 2022", title: "page_main_reviewhead3", body: dictionary["page_main_review3"], name: "MH", color: true },
		{ location: "IND", date: "Aug 25, 2022", title: "page_main_reviewhead4", body: dictionary["page_main_review4"], name: "KA", color: false },
		{ location: "ESP", date: "Jan 15, 2022", title: "page_main_reviewhead5", body: dictionary["page_main_review5"], name: "OT", color: true },
	];

	const reviewsData = type === "main" ? reviewsForMainData : reviewsForBGRData;
	const title = dictionary["page_main_header_reviews"];
	const subtitle = dictionary["Each customer is important for us"];

	return (
		<section className={`${styles.container} ${colorOn ? styles.color : ""}`}>
			<h2 className={styles.title}>{title}</h2>
			<h3 className={`${styles.header} ${styles.subtitle}`}>{subtitle}</h3>
			<div className={styles.content}>
				<Swiper
					effect={"coverflow"}
					grabCursor={true}
					slidesPerView="auto"
					spaceBetween={250}
					loop={true}
					centeredSlides={true}
					autoplay={{ delay: 3500, disableOnInteraction: false, pauseOnMouseEnter: true }}
					keyboard={{ enabled: true }}
					pagination={{ clickable: true }}
					coverflowEffect={{ rotate: 0, depth: 100, modifier: 1, slideShadows: false }}
					breakpoints={{
						1921: { slidesPerView: 3, spaceBetween: 150 },
						1200: { slidesPerView: 2, spaceBetween: 200 },
						1024: { slidesPerView: 1.5, spaceBetween: 100 },
						769: { slidesPerView: 1.5, spaceBetween: 50 },
						481: { slidesPerView: 1.2, spaceBetween: 50 },
						320: { slidesPerView: 1 },
					}}
					modules={[Pagination, EffectCoverflow, Autoplay, Keyboard]}
				>
					{reviewsData.map((item) => {
						return (
							<SwiperSlide key={item.title}>
								<ReviewItem dictionary={dictionary} {...item} />
							</SwiperSlide>
						);
					})}
				</Swiper>
			</div>
		</section>
	);
}

export const MemoizedReviews = memo(UserReviews);
